import { RegionShared } from "@1games-ru/region-shared";
import { BuyDto } from "@1games-ru/region-shared/dist/backend/requests/shop";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class ShopMpProvider {
  // Получить список товаров
  public static async getProducts(
    shopId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetShopProductsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetShopProductsRequest,
      typeof RegionShared.Backend.Responses.GetShopProductsResponse
    >(RegionShared.Backend.Events.Shop.GetShopProducts, { shopId });
  }

  // Купить товары
  public static async buyProducts(
    characterId: number,
    data: BuyDto,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.BuyShopProductsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.BuyShopProductsRequest,
      typeof RegionShared.Backend.Responses.BuyShopProductsResponse
    >(RegionShared.Backend.Events.Shop.BuyShopProducts, { characterId, data });
  }
}
